// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__CP5gF","footer":"ModalError_footer__2B_k1"};